<template>
  <div class="content-banner-content">
    <div
      class="content-banner-image"
      :style="{ backgroundImage: `url(${contentPageStoreBannerImageSrc})` }"
    ></div>
    <div class="content-overlay-image">
      <h1 class="content-banner-title">
        {{ contentPageStoreBannerImageTitle }}
      </h1>
    </div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import ContentPageMixin from "@/mixins/content-page-mixin"
import { ContentPageStore } from '@/store/verbal-identity-page/content-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class ContentBannerSection extends Mixins(ContentPageMixin) {
  contentPageStore: PageStoreContract = getModule(ContentPageStore, this.$store)

  get contentPageStoreBannerImageTitle(): string {
    return this.getElementTitle(0, 0)
  }

  get contentPageStoreBannerImageSrc(): string {
    return this.getElementMedia(0, 0)
  }

  async getContentPageStore(): Promise<void> {
    await this.contentPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.contentPageStore.isLoading) {
      await this.getContentPageStore()
    }
  }
}
</script>

<style lang="scss">
.content-banner-content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: gray;
  max-height: 28rem;
  width: 100%;
  justify-items: center;
  justify-content: center;
}

.content-banner-image {
  position: relative;
  width: 100%;
  height: 451px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.content-overlay-image {
  position: absolute;
  bottom: 9rem;
  left: 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
  z-index: 1;
  pointer-events: none;
  text-align: left;
}

.content-banner-title {
  font-size: 8rem;
  width: 1rem;
  margin: 0;
  font-weight: 400;
  letter-spacing: -0.01em;
  text-align: left;
}
</style>
